import { render, staticRenderFns } from "./Clauses.vue?vue&type=template&id=3e807ab2"
import script from "./Clauses.vue?vue&type=script&lang=js"
export * from "./Clauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports